import {
    login as rlogin,
    setTermsAndConditions,
    suspendedAccount,

} from '../../requests/loader';
import { LOGIN_RESPONSE_TYPE } from './authConstants';
import { parseLoginErrors } from './parseError';
import { STATUS_ACCOUNT_UNDEFINED, STATUS_ACCOUNT_SUSPENDED, STATUS_ACCOUNT_OK } from '../Auth/authConstants';
import ShowCaptchaTask from '../../requests/tasks/user/ShowCaptchaTask';

const byUserHash = (userHashParams) => {
  // Response to return
  const response = {
    response: {},
    success: false
  };
  const { cache = undefined, includpaywayprofile = undefined } = userHashParams;
  if (includpaywayprofile === undefined) {
    userHashParams.includpaywayprofile = true;
  }
  if (cache === undefined) {
    userHashParams.cache = 'all';
  }
  return new Promise(
    (resolve, reject) => {
      rlogin(userHashParams).then((loginResponse) => {
        response.success = true;
        response.response = loginResponse;
        resolve(response);
      }).catch((err) => {
        response.success = false;
        response.response = err;
        reject(response);
      });
    });
};

/**
 * Login by mail & password
 */
const byMail = (email, password, username = undefined, includpaywayprofile = undefined) => {
  // Response to return
  const response = {
    requestResponse: {},
    success: false,
    extraStep: LOGIN_RESPONSE_TYPE.NONE,
    error: null
  };
  // Send only defined params to api/login
  if (!includpaywayprofile) {
    includpaywayprofile = true;
  }
  if (!username) {
    username = email;
  }
  const loginParams = {
    email,
    password,
    username,
    includpaywayprofile
  };
  return new Promise(
    (resolve, reject) => {
      rlogin(loginParams).then((loginResponse) => {
          const { status } = loginResponse;
          if (Number(status) === 0) {
            response.success = true;
            response.requestResponse = loginResponse;
            response.extraStep = LOGIN_RESPONSE_TYPE.NONE;
          } else if (
            (loginResponse &&
              loginResponse.errors &&
              loginResponse.errors.code === LOGIN_RESPONSE_TYPE.ACCEPT_TERMS) ||
            (loginResponse &&
              loginResponse.error &&
              loginResponse.error.code === LOGIN_RESPONSE_TYPE.ACCEPT_TERMS)
          ) {
            response.success = false;
            response.requestResponse = loginResponse;
            response.extraStep = LOGIN_RESPONSE_TYPE.ACCEPT_TERMS;
          }
          // Captcha required? UI need to show captcha field
          else if (
            (loginResponse &&
              loginResponse.error &&
              loginResponse.error.code ===
              LOGIN_RESPONSE_TYPE.USER_LOGIN_CAPTCHA_REQUIRED) ||
            (loginResponse &&
              loginResponse.errors &&
              loginResponse.errors.code ===
              LOGIN_RESPONSE_TYPE.USER_LOGIN_CAPTCHA_REQUIRED)
          ) {
            response.success = false;
            response.requestResponse = loginResponse;
            response.extraStep = LOGIN_RESPONSE_TYPE.USER_LOGIN_CAPTCHA_REQUIRED;
          } else {
            response.success = false;
            response.requestResponse = loginResponse;
            response.extraStep = LOGIN_RESPONSE_TYPE.SHOW_LOGIN_ERROR;
          }

          if (!response.success) {
            response.error = parseLoginErrors(response);
          }
          resolve(response);
        }
      ).catch((err) => {
        response.requestResponse = err;
        response.error = err;

        if (err && err.code === LOGIN_RESPONSE_TYPE.ACCEPT_TERMS) {
          response.success = false;
          response.requestResponse = err;
          response.extraStep = LOGIN_RESPONSE_TYPE.ACCEPT_TERMS;
          resolve(response);
        }
        else if (err && err.code === LOGIN_RESPONSE_TYPE.USER_LOGIN_CAPTCHA_REQUIRED) {
          response.success = false;
          response.requestResponse = err;
          response.extraStep = LOGIN_RESPONSE_TYPE.USER_LOGIN_CAPTCHA_REQUIRED;

          resolve(response);
        }
        else {
          reject(response);
        }
      });
    }
  );
};

const acceptTermAndCond = (loginTermsAndCondParams) => {
    // Response to return
    const response = {
        success: false,
        requestResponse: {}
    };
    if (!loginTermsAndCondParams.username) {
        loginTermsAndCondParams.username = loginTermsAndCondParams.email;
    }
    // Force terminos to 1, 'cause we want to accept
    loginTermsAndCondParams.terminos = 1;
    // TODO: Esta version se debe mandar en una nueva task con la version en el path del servicio 
    loginTermsAndCondParams.api_version = 'v5.94'

    return new Promise(
        (resolve, reject) => {
            setTermsAndConditions(loginTermsAndCondParams).then((tresponse) => {
                if (tresponse && tresponse.status === '0') {
                    response.success = true;
                    response.requestResponse = tresponse;
                    resolve(response);
                }
                else {
                    response.success = false;
                    response.requestResponse = tresponse;
                    reject(response);
                }
            }).catch((err) => {
                response.requestResponse = err;
                response.error = err;
                reject(response);
            });
        }).catch((err) => {
        response.requestResponse = err;
        response.error = err;
        reject(response);
      });
    }

/**
 * Revisa si la cuenta tiene algun adeudo, de ser asi muestra ventana modal bloqueante
 */

const checkAccountStatus = async (result) => {

  const {response : {is_user_logged_in, parent_id, user_id} = {}} = result || {};

  const isUserLoggedIn = !!is_user_logged_in || !!user_id;
  
  if (!isUserLoggedIn) return STATUS_ACCOUNT_UNDEFINED; //Sobre usuario anonimo no se realiza ninguna validacion;

    const params = {
        user_id: parent_id,
    }

    const accountResponse = await suspendedAccount(params).catch((ex)=>{console.error(ex)});
    const  {response : {isSuspended = false} = {}} = accountResponse || {};

    if (isSuspended) {
        return STATUS_ACCOUNT_SUSPENDED;
    } else {
        return STATUS_ACCOUNT_OK;
    }
}

const getCaptcha = () => {
  const showCaptchaTask = new ShowCaptchaTask();
  return `${showCaptchaTask.getImageUrl()}&rnd=${Math.random()}`;
};

/**
 * Main export
 */
const login = {
  byMail,
  byUserHash,
  getCaptcha,
  acceptTermAndCond
};

export { login , checkAccountStatus};



// WEBPACK FOOTER //
// ./src/AAF/Auth/login.js